import { uploadableToConvertionAssetTypes } from './uploadableToConvertionAssetTypes';
import { uploadableWithoutConvertionAssetTypes } from './uploadableWithoutConvertionAssetTypes';

export const uploadableAssetTypes = {
  ...uploadableWithoutConvertionAssetTypes,
  ...uploadableToConvertionAssetTypes,
};
